"use client"

import React, { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import AuthController from './controller/AuthController';
import AuthStorage from './storage/AuthStorage';
//import { usePathname } from 'next/navigation'


export const AppTopbar = (props) => {

    const urlFullLogoMenuDefault = "assets/layout/images/logo-dark.png";

    const [urlFullLogoMenu, setUrlFullLogoMenu] = useState(undefined);
    const [title, setTitle] = useState(undefined);


    useEffect(() => {

        const authStorage = new AuthStorage(window.location.pathname.toLowerCase());
        let dataConfigSubdomain = authStorage.getConfigSubdomain();


        let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoMenu, title } = dataConfigSubdomain;

        let newUrlFullLogoMenu = urlLogoMenu ? process.env.NEXT_PUBLIC_URL_API + urlLogoMenu : urlFullLogoMenuDefault;
        setTitle(title);

        setUrlFullLogoMenu(newUrlFullLogoMenu);


    }, []);



    //console.log("urlFullLogoMenu, ",urlFullLogoMenu);
    const logout = () => {
        const authController = new AuthController();
        authController.logout();
        window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/";
    }

    if (typeof window !== undefined) {
        return (
            <div className="layout-topbar">
                <Link href={process.env.NEXT_PUBLIC_FOLDER_APP + "/"} className="layout-topbar-logo">
                    <img src={props.layoutColorMode === 'light' ? urlFullLogoMenu : 'assets/layout/images/logo-white.svg'} alt="logo" />
                    <span>{title}</span>
                </Link>

                <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                    <i className="pi pi-bars" />
                </button>

                <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                    <i className="pi pi-ellipsis-v" />
                </button>


                <ul className={classNames("layout-topbar-menu lg:flex origin-top", { 'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>

                    <li>
                        <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                            <i className="pi pi-user" />
                            <span>Profile</span>
                        </button>
                    </li>
                    <li className="layout-topbar-action-item">
                        <button className="p-link layout-topbar-button" onClick={logout}>
                            <i className="pi pi-power-off mr-2"></i>
                            <span>Logout</span>
                        </button>
                    </li>

                </ul>
            </div>
        );
    }
    else {
        return (<></>);
    }

    /*
    <li>
                        <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                            <i className="pi pi-calendar"/>
                            <span>Events</span>
                        </button>
                    </li>
                    <li>
                        <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                            <i className="pi pi-cog"/>
                            <span>Settings</span>
                        </button>
                    </li>
    */
}
